import { render } from "./groupList.vue?vue&type=template&id=07e82773&scoped=true&ts=true"
import script from "./groupList.vue?vue&type=script&lang=ts&config=true"
export * from "./groupList.vue?vue&type=script&lang=ts&config=true"

import "./groupList.vue?vue&type=style&index=0&id=07e82773&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07e82773"]])

export default __exports__